<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="main-content-area segunda-via">
        <div class="row flex-box">
          <div class="col-xs-12 col-md-6 flex-vertial-center">
            <p>
              Diariamente, ofertas enlouquecedoras esperam por você. Basta acessar Aldo
              <strong>Crazy Surprise</strong>, durante a semana das 18h às 8h. Nos finais de semana, de sexta às 18h até segunda às 8h. Aproveite
            </p>
            <p>São diversos produtos com preços imbatíveis e qualidade indiscutíveis. Você compra mais barato, alavanca seu empreendimento e garante alta lucratividade.</p>
            <p>
              <strong>Não se esqueça! Todos os dias, você tem hora marcada com o sucesso!</strong>
            </p>
          </div>
          <div class="col-xs-12 col-md-6">
            <img src="/assets/images/crazy-surprise.png" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {};
</script>
